
			<!-- End Responsive header-->
			<div>               
				<div class="pageTitleBannerWrap PrivacyPolicyWrp">
					<h1>Privacy Policy</h1>
				</div>
				<div class="contentSection"> 
					<div class="contentSectionWrap"> 
						<div class="contentSectionDetail cookieWrp">
							<div class="" role="document">
								<div class="">
									<div class="modal-header">
										<div class="modal-title subTitle01-1" id="privacy-policy-popupT" role="heading" aria-level="2">About Tata Consultancy Services Ltd (TCS)</div>
									</div>
									<div class="">
										<div class="">
											<div class="">
												<div class="subTitle01-1" role="heading" aria-level="3">Introduction</div>
												<p>
													Your privacy is important to us. We believe it is important you know how we treat the
													information we receive from you, on the Internet. This privacy statement explains what
													personal data we, Tata Consultancy Services Limited ("Tata Consultancy Services", "TCS" or
													"we"), collect from you, through our interactions with you on this website, and how we use
													that data.
												</p>
												<p>
													TCS™ Web site may contain links to other sites such as TCS™ partners and affiliates. While we
													try to link only to sites that share our high standards and respect for privacy, we are not
													responsible for the content or the privacy practices employed by other sites.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Scope of Data</div>
												<p>
													Tata Consultancy Services collects data to operate this website. You provide some of this
													data directly, such as when you register for an event, subscribe to a newsletter or submit a
													request for further information, or contact us for support.
												</p>
												<p>
													In general, you can visit TCS™ on the World Wide Web without telling us who you are. Our web
													servers collect the domain names, not the e-mail addresses, of visitors. This information is
													aggregated to measure the number of visits, average time spent on the site, pages viewed,
													etc. TCS™ uses this information to measure the use of our site and to improve the content of
													its site.
												</p>
												<p>
													There are times, however, when we may need more information from you, such as your name and
													address. Usually, the contact information we collect is used only by us to respond to your
													inquiry, process an order or allow you to access specific account information. Occasionally,
													we may make the e-mail addresses, of those who provide information, available to other
													reputable organizations whose products or services we think you may find interesting. In
													these cases, you will be offered an opportunity to limit the access of your information to
													such third parties.
												</p>
												<p>
													If you register with one of TCS™ business units online, they may use this information to
													provide you with custom information about TCS™ offering in support of your business needs.
													Cookies may be used to provide you with tailored information. A cookie is a tiny element of
													data that a web site can send to your browser, which may then be stored on your hard drive
													so we can recognize you when you return. You may set your browser to notify you when you
													receive a cookie.
												</p>
												<p>
													At times we conduct online surveys to better understand the needs and profiles of our
													visitors.
												</p>
												<p>
													We get some of it by recording how you interact with our website by, for example, using
													technologies like cookies, or receiving error reports.
												</p>
												<p>
													We also obtain data from third parties. We protect data obtained from third parties according
													to the practices described in this statement, plus any additional restrictions imposed by
													the source of the data. These third-party sources may vary but typically can include:
												</p>
												<p>
													Social networks when you grant permission to us to access your data on one or more networks
													through our website. :
												</p>
												<p>
													Service providers that help us determine a location based on your IP address in order to
													customize offerings and content to your location. :
												</p>
												<p>
													Partners with which we offer co-branded services or engage in joint marketing activities,
													and:
													You have choices about the data we collect. When you are asked to provide personal data, you
													may decline. The data we collect depends on the context of your interactions with Tata
													Consultancy Services, and the choices you make, including your privacy settings. The data we
													collect can include the following: :
													Name and contact data: We collect first and last name, email address, postal address, phone
													number and other similar contact data:
												</p>
												<p>
													Credentials: We collect passwords, password hints and similar security information used for
													authentication and account access.
												</p>
												<p>
													Demographic data: We collect data about you such as your age, gender, country and preferred
													language.
												</p>
												<p>
													Payment data: We collect data necessary to process your payment if you make purchases, such
													as your payment instrument number (such as a credit card number), and the security code
													associated with your payment instrument.
												</p>
												<p>
													Device and Usage data: We collect data about your device and how you and your device interact
													with the Tata Consultancy Services website.
												</p>
												<p>
													Device, connectivity and configuration data: We collect data about your device and the
													network you use to connect to our website. It includes data about the operating systems and
													other software installed on your device, including product keys. It also includes IP
													address, device identifiers (such as the IMEI number for phones), regional and language
													settings.
												</p>
												<p>
													Troubleshooting and Help Data: When you engage Tata Consultancy Services for troubleshooting
													and help, we collect data about you and your hardware, software and other details related to
													the incident. Such data includes contact or authentication data, the content of your chats
													and other communications with Tata Consultancy Services, data about the condition of the
													machine and the application when the fault occurred and during diagnostics, and system and
													registry data about software installations and hardware configurations.
												</p>
												<p>Other?? E.g. location data, content</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Purpose of Data Uses</div>
												<p>
													Tata Consultancy Services uses the data we collect for 2 main purposes, described in more
													detail
													below: to operate our business and this website; and to send communications, including
													promotional communications.
												</p>
												<p>
													Security and Safety: We use data to protect the security and safety of our website.
													Communications: We use data we collect to communicate with you and personalize our
													communications with you. Additionally, you can sign up for email subscriptions and choose
													whether you wish to receive promotional communications from Tata Consultancy Services by
													email,
													SMS, post and telephone or other means of communication. For information about managing your
													contact data, email subscriptions and promotional communications, please submit a request to
													as
													using our contact form at https://www.tcs.com/contact-us
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Sharing Personal Data</div>
												<p>
													We share personal data among Tata Consultancy Services-controlled affiliates and
													subsidiaries. We also share personal data with vendors or agents working on our behalf for
													the purposes described in this statement. For example, companies we've hired to provide
													customer service support or assist in protecting and securing our systems and services may
													need access to personal data to provide those functions.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">We will use, access, or transfer, personal data, when it is required to:</div>
												<p>comply with applicable law or respond to valid legal process;</p>
												<p>
													operate and also maintain the security of this website, including to prevent or stop an
													attack
													on our computer systems or networks;
												</p>
												<p>
													Please note that our website may include links to websites of third parties whose privacy
													practices differ from those of Tata Consultancy Services. If you provide personal data to
													any of
													those websites your data is governed by their privacy statements.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Contacting Us</div>
												<p>
													You can make choices about our collection and use of your data. For example, you may want to
													access, edit or remove the profile information or payment information in your Tata
													Consultancy Services account, change your password, add security information or close your
													account.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Your Communications Preferences</div>
												<p>
													You can choose whether you wish to receive promotional communications from Tata Consultancy
													Services by email, SMS, postal mail and telephone or other communication channels. If you
													receive promotional email or SMS messages from us and would like to opt out, you can do so
													by following the directions in those messages. You can also opt out of email subscriptions
													and choose whether to share your contact information with Tata Consultancy Services
													partners.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Browser-Based Controls</div>
												<p>
													Cookies &amp; Similar Technologies. Tata Consultancy Services uses cookies (small text files
													placed on your device) and similar technologies to provide our websites and to help collect
													data. The text in a cookie often consists of a string of numbers and letters that uniquely
													identifies your computer, but it can contain other information as well.
												</p>
												<p>
													Our Use of Cookies and Similar Technologies. Tata Consultancy Services uses cookies and
													similar technologies for several purposes, which may include:
												</p>
												<p>
													Storing your Preferences and Settings. Settings that enable our website to operate correctly
													or
													that maintain your preferences over time may be stored on your device.
												</p>
												<p>
													Sign-in and Authentication. When you sign into our website using your personal Tata
													Consultancy
													Services account, we store a unique ID number, and the time you signed in, in an encrypted
													cookie on your device. This cookie allows you to move from page to page within the site
													without
													having to sign in again on each page. You can also save your sign-in information so you do
													not
													have to sign in each time you return to the site.
												</p>
												<p>Security. We use cookies to detect fraud and abuse of our websites and services.</p>
												<p>
													Social Media. Some of our websites include social media cookies, including those that enable
													users who are logged in to the social media service to share content via that service.
												</p>
												<p>
													Feedback. Tata Consultancy Services uses cookies to enable you to provide feedback on a
													website.
												</p>
												<p>
													Analytics. In order to provide our website efficiently, we use cookies and other identifiers
													to
													gather usage and performance data. For example, we use cookies to count the number of unique
													visitors to a web page or service and to develop other statistics about the operations of
													our
													website. This includes cookies from Tata Consultancy Services and from third-party analytics
													providers.
												</p>
												<p>
													Performance. Tata Consultancy Services uses cookies for load balancing to ensure that
													websites
													remain up and running.
												</p>
												<p>
													Some of the cookies we commonly use are listed below. This list is not exhaustive, but it is
													intended to illustrate the main reasons we typically set cookies. If you visit one of our
													websites, the site may set some or all of the following cookies:
												</p>
												<p>
													[describe scope of cookies use] In addition to the cookies Tata Consultancy Services sets
													when you visit our websites, third parties may also set cookies when you visit Tata
													Consultancy Services sites. In some cases, that is because we have hired the third party to
													provide services on our behalf, such as site analytics. In other cases, it is because our
													web pages contain content from third parties, such as videos, news content or ads delivered
													by other ad networks. Because your browser connects to those third partiesâ€™ web servers to
													retrieve that content, those third parties are able to set or read their own cookies on your
													device and may collect information about your online activities across websites or online
													services.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">How to Control Cookies</div>
												<p>
													Most web browsers automatically accept cookies but provide controls that allow you to block
													or delete them. For example, certain browser allow to block or delete cookies by clicking
													Settings &gt; Privacy &gt; Cookies.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Our Use of Web Beacons and Analytics Services</div>
												<p>
													Tata Consultancy Services web pages may contain electronic images known as web beacons (also
													called singlepixel gifs) that we use to help deliver cookies on our websites, count users
													who have visited those websites and deliver co-branded products. We also may include web
													beacons in our email messages or newsletters to determine whether you open and act on them.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">European Data Protection Rights - GDPR</div>
												<p>
													Below, you will find additional privacy information that you may find important. Tata
													Consultancy Services adheres to applicable data protection laws in the European Economic
													Area, which if applicable includes the following rights:
												</p>
												<p>
													If the processing of personal data is based on your consent, you have a right to withdraw
													consent at any time for future processing;
												</p>
												<p>
													You have a right to request from us, a "data controller" as defined in the law, access to and
													rectification of your personal data;
												</p>
												<p>You have a right to object to the processing of your personal data; and</p>
												<p>You have a right to lodge a complaint with a data protection authority.</p>
												<p>
													When we process personal data about you, we do so with your consent and/or as necessary to
													provide the website you use, operate our business, meet our contractual and legal
													obligations, protect the security of our systems and our customers, or fulfill other
													legitimate interests of Tata Consultancy Services as described in this privacy statement.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Security of Personal Data</div>
												<p>
													Tata Consultancy Services is committed to protecting the security of your personal data. We
													use a variety of security technologies and procedures to help protect your personal data
													from unauthorized access, use or disclosure.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Where We Store and Process Personal Data</div>
												<p>
													Personal data collected by Tata Consultancy Services may be stored and processed in your
													region, in India, and in any other country where Tata Consultancy Services or its
													affiliates, subsidiaries or service providers operate facilities. The storage location(s)
													are chosen in order to operate efficiently, to improve performance and to create
													redundancies in order to protect the data in the event of an outage or other problem. We
													take steps to ensure that the data we collect under this privacy statement is processed
													according to the provisions of this statement and the requirements of applicable law
													wherever the data is located.
												</p>
												<p>
													We transfer personal data from the European Economic Area and Switzerland to other countries,
													some of which have not been determined by the European Commission to have an adequate level
													of data protection. When we do, we use a variety of legal mechanisms, including contracts,
													to help ensure your rights and protections travel with your data.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Our Retention of Personal Data</div>
												<p>
													Tata Consultancy Services retains personal data for as long as necessary to provide the
													access to and use of the website, or for other essential purposes such as complying with our
													legal obligations, resolving disputes and enforcing our agreements. Because these needs can
													vary for different data types and purposes, actual retention periods can vary significantly.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Changes to This Privacy Statement</div>
												<p>
													We may update this privacy statement from time to time. We encourage you to periodically
													review this privacy statement to learn how Tata Consultancy Services is protecting your
													information.
												</p>
												<div class="subTitle01-1" role="heading" aria-level="3">How to Contact Us</div>
												<p>
													If you have a privacy concern, complaint or a question regarding this privacy statement,
													please direct it to the Chief Privacy Officer of Tata Consultancy Services at
													cbo.tcs&#64;tcs.com or contact us at through this webform:
													https://www.tcs.com/contact-us
												</p>
												<p>[Last updated: Jan 2020]</p>
												<div class="subTitle01-1" role="heading" aria-level="3">Privacy Notice</div>
												<p>Welcome We will use, access, or transfer, personal data, when it is required to:</p>
												<p>comply with applicable law or respond to valid legal process;</p>
												<p>
													operate and also maintain the security of this website, including to prevent or stop an
													attack on our computer systems or networks;
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			